<template xmlns="http://www.w3.org/1999/html">
  <SOSlotModal
    modal-title="Hapus Mesin Snapbridge"
    :modal-id="id"
    @close="close"
  >
    <template v-slot:modal-body>
      <div class="f-c-black f-regular f-16">
        Anda tidak dapat memonitor dan menjalankan mesin secara otomatis jika dihapus. Yakin ingin menghapus mesin?
      </div>
      <div class="f-c-midgrey f-14 f-regular m-t-12">
        Jika ingin menggantinya dengan yang baru, pastikan sudah meng-copy <b>serial number</b> untuk digunakan kembali ketika menambahkan mesin baru.
      </div>
    </template>
    <template v-slot:modal-footer>
      <SOButton
        :outline-danger="true"
        :full="true"
        text="Ya, Hapus"
        :loading="loading"
        @action="deleteMesin"
      />
    </template>
  </SOSlotModal>
</template>

<script>
import SOSlotModal from "@/so-components/global/slot/SOSlotModal";
import SOButton from "@/so-components/global/ui/SOButton";
export default {
  name: "SnapMesinModalDelete",
  components: {SOButton, SOSlotModal},
  props: {
    idHapus: String
  },
  data() {
    return {
      id: "modal-hapus-mesin",
      loading: false
    }
  },
  methods: {
    close() {
      $("#" + this.id).modal("hide");
      setTimeout(() => {
        this.$emit("close")
      }, 500)
    },
    async deleteMesin(){
      let query = {
        idoutlet: this.$route.query.idoutlet,
        idsnap_mesin: this.idHapus
      }

      this.loading = true
      const res = await this.$store.dispatch("snapMesinModule/deleteMesin", query)
      console.log(res)
      if (res.success){
        console.log("mlebu sukses")
        this.loading = false
        this.$emit("onHapusBerhasil", res)
        $("#" + this.id).modal("hide");
      } else {
        console.log("mlebu eror")
        this.loading = false
        this.$toast.error(res.err)
        $("#" + this.id).modal("hide");
      }
    }
  },
  mounted() {
    $("#"+this.id).modal("show")
  }
}
</script>

<style scoped>

</style>